import { render, staticRenderFns } from "./SolicitudEspectacularForm.vue?vue&type=template&id=cc0fd46c&"
import script from "./SolicitudEspectacularForm.vue?vue&type=script&lang=ts&"
export * from "./SolicitudEspectacularForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports